import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { getCaseStudyNameById } from "../modules/casestudies/utils/api";

export function useCaseStudyBreadcrumbData() {
  const { casestudyId } = useParams();
  const [name, setName] = useState(null);
  const [isLoading, setIsLoading] = useState(!!casestudyId);
  const [error, setError] = useState(null);

  useEffect(() => {
    let ignore = false;
    if (casestudyId) {
      setIsLoading(true);
      getCaseStudyNameById(casestudyId)
        .then((result) => {
          if (!ignore) {
            setName(result);
            setIsLoading(false);
          }
        })
        .catch((err) => {
          if (!ignore) {
            setError(err);
            setIsLoading(false);
          }
        });
    } else {
      setName(null);
      setIsLoading(false);
    }
    return () => {
      ignore = true;
    };
  }, [casestudyId]);

  return {
    casestudy: name,
    isLoading: { casestudy: isLoading },
    error,
  };
} 